<app-alert-comp *ngIf="alertOpen" [message]="alertMessage"></app-alert-comp>

<div class="pageContainer">
  <div class="pageContent">
    <form
      style="display: flex; flex-direction: column;"
      class="customInputContainerStyle"
      type="number"
      required
    >
      <label for="basic" class="clr-control-label"
        >How many demo users should be created?</label
      >
      <input
        class="clr-input customInputStyle"
        type="number"
        name="numberOfUsers"
        (change)="numberInputUpdate()"
        [(ngModel)]="numberModal"
        [disabled]="disabled"
        required
        min="1"
        max="50"
      />

      <div style="font-size: 80%; color: rgba(128, 128, 128, 0.726);">
        The count is locked while the user setup wizard is open.
      </div>
    </form>

    <button
      class="btn btn-primary hoverableButton"
      (click)="showModal()"
      [disabled]="numberModalCount > 0 ? false : true"
      [ngStyle]="{
        opacity: numberModalCount > 0 ? 1 : 0,
        height: numberModalCount > 0 ? 'auto' : 0 + 'px'
      }"
    >
      {{ storedUsers ? "Update users" : "Open user setup wizard" }}
    </button>

    <button
      class="btn btn-sm resetStatesButton hoverableButton"
      (click)="clearUsers()"
      style="margin-top: 10px !important; margin-bottom: 10px !important;"
      [disabled]="!storedUsers"
      [ngStyle]="{
        opacity: storedUsers ? 1 : 0,
        height: storedUsers ? 'auto' : 0 + 'px'
      }"
    >
      Clear users
    </button>

    <button
      class="btn btn-outline hoverableButton"
      routerLink="home"
      [disabled]="!storedUsers"
      [ngStyle]="{
        opacity: storedUsers ? 1 : 0,
        height: storedUsers ? 'auto' : 0 + 'px'
      }"
    >
      Back to demo timeline
    </button>
  </div>

  <clr-wizard #wizardxl [(clrWizardOpen)]="xlOpen">
    <clr-wizard-title>User setup wizard</clr-wizard-title>

    <clr-wizard-button [type]="'cancel'">Cancel</clr-wizard-button>
    <clr-wizard-button [type]="'previous'">Back</clr-wizard-button>
    <clr-wizard-button [type]="'next'">Next</clr-wizard-button>
    <clr-wizard-button [type]="'finish'" (click)="submit()"
      >Save users</clr-wizard-button
    >
    <clr-wizard-button (click)="submit()">Save all</clr-wizard-button>

    <clr-wizard-page *ngFor="let user of users; let idx = index">
      <form clrForm [formGroup]="reactiveModel">
        <ng-template clrPageTitle>User {{ idx + 1 }}</ng-template>
        <user-form-comp
          users="users"
          userName="{{ user.name }}"
          userAvatarUrl="{{ user.avatarUrl }}"
          idx="{{ idx }}"
          (onKeyUpEvent)="onKey($event)"
          (onSubmitEvent)="submit()"
        ></user-form-comp>
      </form>
    </clr-wizard-page>
  </clr-wizard>
</div>
